import { useQuery } from "@tanstack/react-query";
import { documentsApi } from "../../api/documentsApi";
export var DOCUMENTS_QUERY_KEY = "admin-documents";
export var useDocuments = function (page, limit) {
    return useQuery({
        queryKey: [DOCUMENTS_QUERY_KEY, page, limit],
        queryFn: function () { return documentsApi.list({ page: page, limit: limit }); },
    });
};
